import { SyntheticEvent, memo } from "react";
import { Table, TableHeader, TableRow, TableHeaderCell, TableBody, Icon, Label, TableCell, Item, Checkbox, CheckboxProps } from "semantic-ui-react";

// Serializers
import PublishedDiagRuleNodeMemberSerializer from "@/issara-sdk/types/PublishedDiagRuleNodeMemberSerializer_apps_PRX";

// Style
import "./styles/TableMemberGroup.scss";
import { PatientDetailMap } from "./MeCastType";
import ProxyPatientSerializer from "@/issara-sdk/types/ProxyPatientSerializer_apps_PRX";
import moment from "moment";

type TableHandleMemberNodeProps = {
  // data
  memberNodeList: PublishedDiagRuleNodeMemberSerializer[];
  patientDetailMap: PatientDetailMap;
  changedMembers: Map<number, boolean>;
  // actions
  onMemberActiveChange:(memberId: number, active: boolean) => void;
};

const TableHandleMemberNode = (props: TableHandleMemberNodeProps) => {

  const { memberNodeList, patientDetailMap, changedMembers, onMemberActiveChange } = props;

  const handleCheckboxChange = (memeberId: number) => (
    _: SyntheticEvent,
    data: CheckboxProps
  ) => {
    onMemberActiveChange(memeberId, !!data.checked);
  };

  const getMemberActiveState = (member: PublishedDiagRuleNodeMemberSerializer): boolean => {
    if (changedMembers.has(member.id as number)) {
      return changedMembers.get(member.id as number) as boolean;
    }
    return member.active ?? true;
  };

  const getPatientDetail = (patientId?: number): ProxyPatientSerializer | undefined => {
    if (!patientId) return undefined;

    return patientDetailMap[patientId];
  };

  return (
    <div className="table-handle-member-node">
      <Table basic structured>
        {/* --- Header --- */}
        <TableHeader>
          <TableRow>
            <TableHeaderCell width={2}>
              <label style={{ paddingLeft: "8px" }}>Member ID</label>
            </TableHeaderCell>
            <TableHeaderCell width={3}>
              <label style={{ paddingLeft: "8px" }}>Name</label>
            </TableHeaderCell>
            <TableHeaderCell width={3}>
              <label style={{ paddingLeft: "8px" }}>CID / Passport</label>
            </TableHeaderCell>
            <TableHeaderCell width={2}>
              <label style={{ paddingLeft: "8px" }}>DOB</label>
            </TableHeaderCell>
            <TableHeaderCell width={3}>
              <label style={{ paddingLeft: "8px" }}>Email</label>
            </TableHeaderCell>
            <TableHeaderCell width={2}>
              <label style={{ paddingLeft: "8px" }}>Mobile</label>
            </TableHeaderCell>
            <TableHeaderCell width={1}>
              <label style={{ textAlign: "center" }}>Active</label>
            </TableHeaderCell>
          </TableRow>
        </TableHeader>

        {/* --- Body --- */}
        <TableBody>
          {memberNodeList.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={7}
                textAlign="center"
                style={{
                  color: "#999",
                  fontSize: "24px",
                  height: "calc(55vh + 0.25rem)"
                }}
              >
                <label>No Member In This Group</label>
              </TableCell>
            </TableRow>
          ) : (
            <>
              {memberNodeList.map((member: PublishedDiagRuleNodeMemberSerializer, index: number) => {
                const memberId = member.id as number;
                const isActive = getMemberActiveState(member);
                const hasChanged = changedMembers.has(memberId);
                const patientDetail = getPatientDetail(member.patient);

                return (
                  <TableRow
                    key={member.id}
                  >
                    <TableCell width={2}>
                      {member.hn}
                    </TableCell>
                    <TableCell width={3}>
                      {member.patient_name}
                    </TableCell>
                    <TableCell width={3}>
                      {patientDetail?.cid || "-"}
                    </TableCell>
                    <TableCell width={2}>
                      {patientDetail?.birthdate ? moment(patientDetail?.birthdate).format("DD/MM/YYYY") : "-"}
                    </TableCell>
                    <TableCell width={3}>
                      {patientDetail?.email || "-"}
                    </TableCell>
                    <TableCell width={2}>
                      {patientDetail?.phone_no || "-"}
                    </TableCell>
                    <TableCell width={1}>
                      <Checkbox
                        checked={isActive}
                        onChange={handleCheckboxChange(memberId)}
                      />
                    </TableCell>
                  </TableRow>
                )
              })}
            </>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default memo(TableHandleMemberNode);